import axios from 'axios';
import { checkValidation } from '../actions/landingActions';

export const setupAxiosInterceptors = (store) => {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const url = error?.config?.url ?? '';

      // 401s from the token endpoint are expected (wrong zip) and handled
      // locally by DigitalQuoteAuthenticationPage — don't interfere.
      if (status === 401 && !url.includes('/api/auth/token')) {
        store.dispatch(checkValidation());
      }

      return Promise.reject(error);
    },
  );
};
